/*
  Как начислены пени за выбранный месяц - под услугами месяца на странице «Как
  сформировался долг» (решение владельца 05.10.2026).

  Строки - те же, что уходят в суд приложением к заявлению и что видит должник
  на своей странице (`legal/documents/penalty_steps.py`): по строке на каждую
  ступень просрочки долга месяца. С 06.10.2026 пени считаются от долга месяца
  целиком, как в расчёте юриста, и колонки «Услуга» нет: обычно здесь две
  строки - 1/300 и 1/130. Формулу собирает сервер из настоящих чисел -
  «6 380,91 × 9,5% / 130 × 240», - чтобы расчёт проверялся умножением на бумаге
  и не мог разойтись с судебным.
*/

import { date, money, plural } from '../api/format.js'

function Days({ step }) {
  if (!step.excluded_days) return step.days
  return (
    <>
      {step.days}
      <div className="muted">без {plural(step.excluded_days, 'дня', 'дней', 'дней')} моратория</div>
    </>
  )
}

export default function DebtMonthPenalty({ month, notice }) {
  if (notice) {
    return (
      <>
        <h3 className="debt-detail__subtitle">Как начислены пени</h3>
        <div className="muted">{notice}</div>
      </>
    )
  }
  if (!month) {
    return (
      <>
        <h3 className="debt-detail__subtitle">Как начислены пени</h3>
        <div className="muted">По этому месяцу пени не начислены: срок оплаты ещё не прошёл.</div>
      </>
    )
  }
  return (
    <>
      <h3 className="debt-detail__subtitle">Как начислены пени</h3>
      <div className="debt-detail__scroll">
      <table className="table">
        <thead>
          <tr>
            <th className="table__num">Долг</th>
            <th>Период просрочки</th>
            <th className="table__num">Дней</th>
            <th>Формула</th>
            <th className="table__num">Пени</th>
          </tr>
        </thead>
        <tbody>
          {month.steps.map((step) => (
            <tr key={step.starts}>
              <td className="table__num" data-label="Долг">
                {money(step.base)}
              </td>
              <td data-label="Период просрочки">
                {date(step.starts)} - {date(step.ends)}
              </td>
              <td className="table__num" data-label="Дней">
                <Days step={step} />
              </td>
              <td data-label="Формула">{step.formula}</td>
              <td className="table__num" data-label="Пени">
                {money(step.amount)}
              </td>
            </tr>
          ))}
        </tbody>
        <tfoot>
          <tr className="debt-detail__total">
            <td colSpan={4}>Итого пени за месяц</td>
            <td className="table__num" data-label="Пени">
              {money(month.amount)}
            </td>
          </tr>
        </tfoot>
      </table>
      </div>
    </>
  )
}
